import { render } from "./BotAvatar.vue?vue&type=template&id=6e42f372&scoped=true&ts=true"
import script from "./BotAvatar.vue?vue&type=script&lang=ts"
export * from "./BotAvatar.vue?vue&type=script&lang=ts"

import "./BotAvatar.vue?vue&type=style&index=0&id=6e42f372&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e42f372"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar});
